<div
    class="flash-message-container"
    [ngClass]="{ flashing: isFlashing() }"
    (click)="stopFlashing()"
    [innerHTML]="getFlashMessage()"
></div>
